module.exports = __webpack_public_path__ + "7dc8dfe757637ccd14fa887dd7265b09.png";